const wallpapers = {
  day: "img/macos/ui/wallpaper-day.jpg",
  night: "img/macos/ui/wallpaper-night.jpg",
};

export default wallpapers;
